export const px = value => `${value.toString()}px`

export const url = (path) => `url(${path})`
